import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    number: "01",
    title: "Kort samtale",
    text: "Vi tager en uforpligtende snak om din virksomhed, dine ønsker og hvad hjemmesiden skal hjælpe dig med.",
  },
  {
    number: "02",
    title: "Designforslag",
    text: "Du får et visuelt oplæg og en fast pris på skrift — før der bliver lavet noget som helst.",
  },
  {
    number: "03",
    title: "Vi bygger",
    text: "Vi designer og bygger hele hjemmesiden og holder dig opdateret undervejs. Du godkender, før noget går live.",
  },
  {
    number: "04",
    title: "Hjemmesiden går live",
    text: "Siden lægges online, og vi viser dig, hvordan du nemt selv kan rette små ting fremover.",
  },
];

export const Process = () => (
  <section className="py-20 sm:py-28 bg-zinc-900 text-white" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 mb-4">
          Sådan fungerer det
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight max-w-2xl">
          Fra første snak til færdig hjemmeside i fire trin
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.number} delay={i * 0.12}>
            <div data-testid={`process-step-${i + 1}`} className="border-t border-zinc-700 pt-6">
              <span className="font-mono-accent text-sm text-zinc-500">{s.number}</span>
              <h3 className="mt-3 text-xl font-semibold">{s.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
